<template>
  <div class="brand" aria-label="BTP 區塊鏈交易平台">
    <span class="brand__mark" aria-hidden="true"><i></i><i></i><i></i></span>
    <span class="brand__copy">
      <strong>BTP</strong>
      <small>區塊鏈交易平台</small>
    </span>
  </div>
</template>

